import { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader2, CheckCircle, AlertCircle } from 'lucide-react';
import { apiFetchJson } from './api';

export default function BoutiqueCallback() {
  const navigate = useNavigate();
  const [status, setStatus] = useState('processing');
  const [message, setMessage] = useState('');

  const handleCallback = useCallback(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    if (!code) {
      setStatus('error');
      setMessage('Aucun code reçu. Réessayez depuis la page boutique.');
      return;
    }
    const callbackUri = `${window.location.origin}/my/boutique/callback`;
    apiFetchJson('/api/my/boutique/auth/connect', {
      method: 'POST',
      body: JSON.stringify({ code, redirect_uri: callbackUri }),
    }, 'Erreur de connexion boutique')
      .then(() => {
        setStatus('success');
        setTimeout(() => navigate('/my/boutique', { replace: true }), 1500);
      })
      .catch(err => {
        setStatus('error');
        setMessage(err.message);
      });
  }, [navigate]);

  useEffect(() => { handleCallback(); }, [handleCallback]);

  return (
    <div className="min-h-screen bg-[#0d0f14] flex items-center justify-center p-4">
      <div className="bg-[#12141a] border border-white/5 rounded-2xl p-8 max-w-sm w-full text-center">
        {status === 'processing' && (
          <>
            <Loader2 className="w-10 h-10 text-[#0099D6] animate-spin mx-auto mb-4" />
            <p className="text-white font-semibold mb-1">Connexion en cours...</p>
            <p className="text-gray-500 text-sm">Échange du code d'authentification avec la boutique.</p>
          </>
        )}
        {status === 'success' && (
          <>
            <CheckCircle className="w-10 h-10 text-emerald-400 mx-auto mb-4" />
            <p className="text-white font-semibold mb-1">Boutique connectée !</p>
            <p className="text-gray-500 text-sm">Redirection vers la gestion des produits...</p>
          </>
        )}
        {status === 'error' && (
          <>
            <AlertCircle className="w-10 h-10 text-red-400 mx-auto mb-4" />
            <p className="text-white font-semibold mb-2">Erreur de connexion</p>
            <p className="text-red-400 text-sm mb-6">{message}</p>
            <button
              onClick={() => navigate('/my/boutique', { replace: true })}
              className="inline-flex items-center gap-2 bg-white/5 hover:bg-white/10 text-gray-300 font-medium py-2.5 px-5 rounded-xl transition-colors text-sm"
            >
              Retour à la boutique
            </button>
          </>
        )}
      </div>
    </div>
  );
}
